import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/mh200/h5/');

export default function MhHh5() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn', 'au']);
    const { t } = useLang('waveportableairconditioner');

    return (
        <div className={`${css.mhHh5} mhHh5`}>
            <div className="mh-inter">
                <div className="ms-title"> {t('mh200.mhTA_ms1_h5')}</div>
                <div className="ms-text">
                    {t('mh200.mhTA_ms2')}
                    <div className="list-box">
                        <div className="list-item list-item-a">
                            <div className="img-box-out">
                                <div className="img-box">
                                    <EFPic name={[`delta_a_1_${imgLocal}.webp`, `delta_a_1_${imgLocal}.png`]} className="fullImgs" alt={t('mh200.mhH_ms1')} />
                                </div>
                            </div>
                            <div className="ms-box">{t('mh200.mhH_ms1')}</div>
                        </div>
                        <div className="list-item list-item-b">
                            <div className="img-box-out">
                                <div className="img-box">
                                    <EFPic name={["delta_a_2.webp", "delta_a_2.png"]} className="fullImgs" alt={t('mh200.mhH_ms2')} />
                                </div>
                            </div>
                            <div className="ms-box">{t('mh200.mhH_ms2')}</div>
                        </div>
                        <div className="list-item list-item-c">
                            <div className="img-box-out">
                                <div className="img-box">
                                    <EFPic name={["delta_a_3.webp", "delta_a_3.png"]} className="fullImgs" alt={t('mh200.mhH_ms3')} />
                                </div>
                            </div>
                            <div className="ms-box">{t('mh200.mhH_ms3')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
